import { render, staticRenderFns } from "./ManageProductCategoriesModal.vue?vue&type=template&id=736d63cd&scoped=true"
import script from "./ManageProductCategoriesModal.vue?vue&type=script&lang=js"
export * from "./ManageProductCategoriesModal.vue?vue&type=script&lang=js"
import style0 from "./ManageProductCategoriesModal.vue?vue&type=style&index=0&id=736d63cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736d63cd",
  null
  
)

export default component.exports